import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import Tibbits from '@appblocks/codegeneration/Tibbits/index';
import {
    CodeBlock,
    BlockType,
    SettingType,
    SettingState,
    ValidationMessage,
    ValidationMessageType,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';

export default class Tibbit_63 extends BaseTibbit {
    constructor() {
        super();
        this.id = 'tibbit_63';
        this.name = 'Tibbit 63';
        this.settings = this.settings.concat([
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.NAME,
                dataType: TibboDataType.BOOLEAN,
                required: true,
                default: '',
            },
            {
                id: 'INTERRUPT',
                name: 'Interrupt',
                settingType: SettingType.OPTION,
                required: true,
                default: '0',
                options: [
                    {
                        name: 'Disabled',
                        value: '0',
                    },
                    {
                        name: 'Enabled',
                        value: '1',
                    },
                ],
            },
        ]);
    }

    getState(settingId: string): SettingState {
        const interruptNumber = Tibbits.getSocket(this.getSettingValue('SOCKET'), this.project.device.id)?.interrupt;
        const interruptEnum = PlatformUtils.getEnum(interruptNumber, 'pl_int_num', this.project.device.platform);
        if (settingId === 'INTERRUPT' && interruptEnum === null) {
            return SettingState.DISABLED;
        }
        return SettingState.ENABLED;
    }

    validate(): ValidationMessage[] {
        const errors: ValidationMessage[] = [];
        const interruptNumber = Tibbits.getSocket(this.getSettingValue('SOCKET'), this.project.device.id)?.interrupt;
        const interruptEnum = PlatformUtils.getEnum(interruptNumber, 'pl_int_num', this.project.device.platform);
        for (let i = 0; i < this.settings.length; i++) {
            const setting = this.settings[i];
            if (setting.id === 'INTERRUPT' && interruptEnum === null) {
                errors.push({
                    messageType: ValidationMessageType.UPDATE,
                    message: '',
                    settingId: 'INTERRUPT',
                    featureId: this.getID(),
                    data: '0',
                });
            }
        }
        return errors;
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];

        if (this.project.runtime === 'simulator') {
            return [];
        }

        const interruptNumber = Tibbits.getSocket(this.getSettingValue('SOCKET'), this.project.device.id)?.interrupt;
        const interruptEnum = PlatformUtils.getEnum(interruptNumber, 'pl_int_num', this.project.device.platform);
        const interruptValue = PlatformUtils.getEnumValue(interruptNumber, 'pl_int_num', this.project.device.platform);
        const interruptBit = Math.pow(2, Number(interruptValue));
        const socketNumber = this.getSettingValue('SOCKET');
        const useInterrupt = this.getSettingValue('INTERRUPT');
        const name = this.getSettingValue('NAME');

        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template: `
    'Tibbit 63 setup on socket ${socketNumber}
    io.num=${name}_L4
    io.enabled=NO`,
        });

        blocks.push({
            location: 'GLOBAL_CONSTS',
            blockType: BlockType.CODE,
            template: `
const ${name}_L4 = ${Tibbits.getSocketPins(socketNumber, this.project.device.id)[3]}`,
        });

        if ((interruptEnum !== null) && (useInterrupt === '1')) {
            blocks.push({
                location: 'boot',
                blockType: BlockType.CODE,
                template: `
    io.intnum=${name}_INT_NUM
    io.intenabled=YES`,
            });

            blocks.push({
                location: 'GLOBAL_CONSTS',
                blockType: BlockType.CODE,
                template: `
const ${name}_INT_NUM = ${interruptEnum}`,
            });
        }

        blocks.push({
            location: `var_${name}_update`,
            blockType: BlockType.CODE,
            template: `
var_${name}_update_completed(io.lineget(${name}_L4))`,
        });

        return blocks;
    }

    getDetails(): string {
        return 'https://docs.tibbo.com/tibbit_63';
    }
}
